<template>
    <div>
        <transition name="fade">
            <Row v-if="mainTable.sarchCardShow"
                :gutter="16">
                <Col span="24">
                <search-card :form="mainTable.searchForm"
                    :table-load-event="getMainTableRecords"
                    :table-search="mainTable.tableSearch" />
                </Col>
            </Row>
        </transition>

        <Card>
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">产品审批记录</span>
                    </div>
                    <div class="right-bar">
                        <Button v-if="$checkAccessArray(['B', 'C'])"
                            size="small"
                            class="btns"
                            shape="circle"
                            type="success"
                            icon="ios-add-circle-outline"
                            @click="onCreate">新增</Button>
                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.tableColumns"
                    :data="mainTable.tableData"
                    :loading="mainTable.tableLoading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getMainTableRecords" />
                </Col>
            </Row>
        </Card>

        <ProductApproveDetail ref="productApproveDetailModal" />
        <ProductApproveCreate ref="productApproveCreateModal" />
    </div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import search from '@/libs/search';
import { dateRender, dateTimeRender } from '@/libs/tableRowTimeRender';
import ProductApproveDetail from './productApprove-detail';
import ProductApproveCreate from './productApprove-create';
import { getProductApproveList } from '@/api/modules/product-management/productApprove-management';

export default {
    name: 'productApprove-list',
    components: {
        StandPaginationTable,
        SearchCard,
        ProductApproveDetail,
        ProductApproveCreate
    },
    data() {
        return {
            mainTable: {
                tableColumns: [
                    { title: '行号', type: 'index', width: 80, align: 'center' },
                    { title: '苗场编号', key: 'seedFarmCode', align: 'center' },
                    { title: '苗场', key: 'seedFarmName', align: 'center' },
                    { title: '发起人', key: 'userPersonName', align: 'center' },
                    { title: '产品数量', key: 'productApproveRecordAmount', align: 'center' },
                    { title: '审批进度', key: 'productApproveRecordProgress', align: 'center' },
                    { title: '申请时间', key: 'productApproveRecordCreateAt', align: 'center', render: (h, params) => dateTimeRender(h, params.row.productApproveRecordCreateAt) },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        width: 150,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    on: {
                                        click: () => {
                                            this.onEdit(params.row);
                                        }
                                    }
                                }, '查看')
                            ]);
                        }
                    }
                ],
                tableData: [],
                tableLoading: false,
                tableSearch: search.getSearchParams(),
                sarchCardShow: false,
                searchForm: [
                    { label: '苗场', type: 'Input', value: '', name: 'seedFarmName', sql: 'like' },
                    { label: '苗场编号', type: 'Input', value: '', name: 'seedFarmCode', sql: 'like' }
                ]
            }
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.getMainTableRecords();
        },
        getMainTableRecords(reset = false) {
            this.mainTable.tableLoading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            getProductApproveList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.tableData = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.tableLoading = false;
            });
        },
        onCreate() {
            this.$refs.productApproveCreateModal.showModal();
            // this.$router.push({
            //     name: 'productApprove-create'
            // });
        },
        onEdit(row) {
            this.$refs.productApproveDetailModal.showModal(row.productApproveRecordUuid);
            // this.$router.push({
            //     name: 'productApprove-detail',
            //     query: {
            //         productApproveRecordUuid: row.productApproveRecordUuid
            //     }
            // });
        }
    }
};
</script>

<style scoped>
</style>
